export function setItem<T>(key: string, value: T): void {
  if (typeof window === 'undefined') return;
  try {
    const serialized = JSON.stringify(value);
    window.localStorage.setItem(key, serialized);
  } catch (error) {
    console.error(`Error setting localStorage key “${key}”:`, error);
  }
}

export function getItem<T>(key: string, fallback?: T): T | null {
  if (typeof window === 'undefined') return fallback ?? null;
  try {
    const item = window.localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : (fallback ?? null);
  } catch (error) {
    console.error(`Error getting localStorage key “${key}”:`, error);
    return fallback ?? null;
  }
}

export function removeItem(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing localStorage key “${key}”:`, error);
  }
}
